module.exports = __webpack_public_path__ + "img/kitchen_dark.4c177f31.png";